import { usePageErrorStore } from 'frontend/stores/PageErrorStore';

export default function usePageError() {
  const { setPageError } = usePageErrorStore();
  return {
    showError: setPageError,
  };
}
